export class DataDriver {
    constructor(pmdrs) {
        this.pmdrs = pmdrs;
        this.apr = {};
        this.initialPayments = {};//key by deal type
    }

    getPayment(taxes, type, paymentData, successCallback, errorCallback){
        console.error("function not implemented");    
    }

    getInitialPayment(type, successCallback, errorCallback){
        console.error("function not implemented");    
    }

    getCashPriceLabel(){
        return 'Sale Price';
    }

    getThemeClass() {
        return this.themeClass;
    }

    getCreditRanges() {
        return this.apr.range_config;
    }

    getAPRFinanceTable() {
        return this.apr.finance ? this.apr.finance.ratings : null;
    }

    getAPRBalloonTable() {
        var balloonTable = this.apr.balloon;
        if(this.balloonCashMode){
            balloonTable = this.apr.balloonCash || balloonTable; 
        }
        return balloonTable || [];
    }

    // getAPRPremierTable() {
    //     return this.apr.balloon || [];
    // }

    // getAPRTTFTable() {
    //     return this.apr.balloon || [];
    // }

    getAPRLeaseTable() {
        return this.apr.lease;
    }

    getOptions() {
        return this.apr.options;
    }

    getFees() {
        return this.apr.fees || [];
    }

    getYoutubeOverviewVideo() {
        return this.apr.tradeInOverviewVideo || "about:blank";
    }

    getYoutubeImagesVideo() {
        return this.apr.tradeInImagesVideo || "about:blank";
    }

    getYoutubeTestRideVideo() {
        return this.apr.testRideVideo || "";
    }

    getYoutubePreApprovedVideo() {
        return this.apr.preApprovedVideo || "";
    }

    isPixelmotion(){
        return this.key == DataDriver.PIXELMOTION_KEY;
    }

    isOfferlogix(){
        return this.key == DataDriver.OFFERLOGIX_KEY;
    }

    isLenderDesk(){
        return this.key == DataDriver.LENDERDESK_KEY;
    }

    getDefaultCreditRatingLabel(dealType){
        var label = "noRatingLabel";
        switch (dealType) {
            case "finance":
                label = this.getAPRFinanceTable()[0].label;
                break;
            case "balloon":
                const ratings = this.getAPRBalloonTable().ratings;
                if(ratings){
                    label = ratings[0].label;
                }
                break;
            // case "premier":
            //     label = this.getAPRPremierTable().ratings[0].label;
            //     break;
            // case "ttf":
            //     label = this.getAPRTTFTable().ratings[0].label;
            //     break;
        }
        return label;
    }

    getLeaseAprTableByMPY(mpy) {
        let aprTable = null;
        (this.getAPRLeaseTable() || []).forEach((item) => {
            if (item.mpy == mpy) {
                aprTable = item.ratings;
            }
        });
        return aprTable;
    }

    getMillesPerYearOptionsForLease() {
        let mpys = [];
        (this.getAPRLeaseTable() || []).forEach((item) => {
            mpys.push(item.mpy);
        });
        return mpys;
    }

    getTermsOptions(dealType, creditRatingLabel, mpy){
        let ratingAPR = [];
        switch (dealType) {
            case "lease":
                let mpyAprTable = this.getLeaseAprTableByMPY(mpy);
                if(mpyAprTable){
                    ratingAPR = mpyAprTable.find((element) => element.label === creditRatingLabel);
                }
                break;

            case "finance":
                const financeTable = this.getAPRFinanceTable();
                if (financeTable) {
                    ratingAPR = financeTable.find((elemet) => elemet.label === creditRatingLabel);
                }
                break;

            case "balloon":
                const ratings = this.getAPRBalloonTable().ratings;
                if(ratings){
                    ratingAPR = this.getAPRBalloonTable().ratings.find((elemet) => elemet.label === creditRatingLabel);
                }
                break;

            // case "premier":
            //     ratingAPR = this.getAPRPremierTable().ratings.find((element) => element.label === creditRatingLabel);
            //     break;

            // case "ttf":
            //     ratingAPR = this.getAPRTTFTable().ratings.find((element) => element.label === creditRatingLabel);
            //     break;
            default:
                break;
        }

        if (dealType === "term-balloon" && this.pmdrs.frontApp.isBMW()) {//whats the difference between term-balloon and dealType balloon? why for BMW
            ratingAPR = this.app.balloonTable().ratings.find((elemet) => elemet.label === selectedRating);
        }
        var options = [];
        for (var index in ratingAPR?.terms) {
            options.push(index);
        }
        return options;
    }

    getFormatedInitialPayments(){
        var $this = this;
        var apiPayments = this.initialPayments;
        let pDataByDeal = {};
        // if ($this.pmdrs.frontApp.pmdrs.config.accountId == "delamomotorsports") this.pmdrs.allDealTypes.push('finance_lower_rate');
        this.pmdrs.allDealTypes.forEach(function(dealType){
            let pData = apiPayments[dealType];
            // dealType = dealType == "finance_lower_rate" ? "finance" : dealType;
            if(pData){
                pDataByDeal[dealType] = $this.formatApiPayment(pData);
            }
        });
        console.log(pDataByDeal);
        return pDataByDeal;
    }    

    precachePayments(paymentData, type, accessoriesPrices){
        return;
    }

    /**
     * @param object
     * All drivers should call this so any new attribute gets a default value
     * this PaymentObject has monthly payment, it's the response in getPayment functions
     */
    formatPaymentObject({
            dealType,
            moneyFactor,
            monthlyPayment,
            totalPayments,
            downPayment,
            term,
            creditRating,
            purchasePrice,
            expirationDate = "",
            incentives = {},
            incentivesTotal = 0,
            conditionalOffers = {},
            disclaimerText = null, // default to null
            ratingBalloonAPR = null,//used by balloon, premier, ttf (PM driver)
            feesAndTaxesTotal = null,//null in PM, float in allCarUsa or any other driver
            feesAndTaxesList = null,//null in PM, float in allCarUsa or any other driver
            lenderId = null,
            lenderName = null,//real bank/lender display name, only set by drivers backed by an actual lender (e.g. LenderDeskDriver)
            balloonPayment,
            balloonType,
            customerCash,
            payment,
            financedAmount,
            docFee = null,
            dueAtSign = null,
            paymentBeforeTaxes = null,
            leaseTaxesTotal = null,
            leaseGovFeesTotal = null,
            priceStack = null,//optional, dealer-exact price breakdown (pilot: lampedodge PmRates quotes) — see PmRates::buildPriceStack
            // Server-computed display totals from pm-drs-api (PaymentHelper::
            // addComputedDisplayFields) — computed for every engine, every request; null only
            // if a response somehow predates this. Every one of these was silently getting
            // dropped here before this fix: PaymentSection.js's useServerComputedTotals
            // branches (since removed — server totals are unconditional now) were
            // live-verified to always fall through to their client-computed fallback
            // (matching by coincidence of formula, not because the server value was actually
            // read) until this destructuring caught up.
            docFeeForTotal = null,
            docFeeDisplay = null,//what the itemized Doc Fee row shows — non-zero even when docFeeForTotal is 0 because the fee is already inside financedAmount (LenderDesk finance)
            cashDownDisplay = null,
            netPriceDisplay = null,
            finalPriceDisplay = null,
            isValid = null,
            dueAtSignBase = null,
            dueAtSignWithTaxes = null,
            residualValue = null,//lease-only, from LenderDesk
            residualPercentage = null,//lease-only, from LenderDesk
        } = {}){
        return {
            dealType,
            moneyFactor,
            monthlyPayment,
            totalPayments,
            downPayment,
            term,
            expirationDate,
            incentives,
            incentivesTotal,
            conditionalOffers,
            disclaimerText,
            ratingBalloonAPR,
            feesAndTaxesTotal,
            feesAndTaxesList,//array of objects {label, amount}
            lenderId,//string or null
            lenderName,//string or null
            creditRating,//score like 850, not credit rating key or label like Ultra
            purchasePrice,//sale price but with rebates or edits
            balloonPayment,
            balloonType,
            customerCash,
            payment,//this one could replace monthly payment, it'll need a refactor
            financedAmount,
            docFee,//top-level field from LenderDesk API
            dueAtSign,//down + first month from API (not used directly for total — computed from line items)
            paymentBeforeTaxes,//base monthly payment before taxes; monthlyTaxes = payment - paymentBeforeTaxes
            leaseTaxesTotal,//sum of feeDetails where feeType === 'Sales'
            leaseGovFeesTotal,//sum of feeDetails where feeType === 'Registration'
            priceStack,
            docFeeForTotal,
            docFeeDisplay,
            cashDownDisplay,
            netPriceDisplay,
            finalPriceDisplay,
            isValid,
            dueAtSignBase,
            dueAtSignWithTaxes,
            residualValue,
            residualPercentage,
        };
    }

    getTaxesBtnText(){
        if (this.pmdrs.frontApp.pmdrs.config.accountId == "delamomotorsports") return "Apply Estimated Sales Tax";
        return "Apply";
    }
}

DataDriver.OFFERLOGIX_KEY = "offerlogix";
DataDriver.LENDERDESK_KEY = "lenderdesk";
DataDriver.PIXELMOTION_KEY = "pixelmotion";
DataDriver.PMRATES_KEY = "pmrates";
